import { RootState } from '@client/redux/types';
import { NAMESPACE } from './state';

export const getContinueShoppingData = (state: RootState) => state[NAMESPACE].data;
export const getIsLoading = (state: RootState) => state[NAMESPACE].loading;
